document.addEventListener('DOMContentLoaded', () => {
    const $menuElement = document.getElementById('mainmenu');
    const $navbarBurger = document.getElementById('navbar-burger');

    if (typeof $navbarBurger !== 'undefined' && typeof $menuElement !== 'undefined') {
        const $burgerLabel = $navbarBurger.querySelector('.hamburger-label');

        $navbarBurger.addEventListener('click', () => {
            $navbarBurger.classList.toggle('is-active');
            $menuElement.classList.toggle('is-active');
            document.documentElement.classList.toggle('has-menu-open');
            if ($navbarBurger.classList.contains('is-active')) {
                $burgerLabel.innerHTML = $navbarBurger.dataset.closeText;
            }
            else {
                $burgerLabel.innerHTML = $navbarBurger.dataset.menuText;
            }
        });

        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($menuElement.contains(event.target) || $navbarBurger.contains(event.target)) {
                isClickInside = true;
            }

            if (!isClickInside) {
                $navbarBurger.classList.remove('is-active');
                $menuElement.classList.remove('is-active');
                $burgerLabel.innerHTML = $navbarBurger.dataset.menuText;
                document.documentElement.classList.remove('has-menu-open');
            }
        });
    }
});
